import { IIconProps } from "../types"

export default function IconUL6(props: IIconProps) {
  const width = props.size || props.width || 90
  const height = props.size || props.height || 78
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 90 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.1704 1.20275C50.9804 0.612745 41.8704 0.542745 34.8404 1.33275C27.8104 2.11275 22.8604 3.73274 19.5104 5.36274C16.1504 6.99274 14.3904 8.62275 12.3404 11.8727C10.2904 15.1327 7.9504 20.0127 5.9104 24.8627C3.8704 29.7127 2.1404 34.5327 1.3204 40.1627C0.510405 45.7927 0.620405 52.2427 1.2904 57.2827C1.9604 62.3327 3.2004 65.9727 5.0204 68.9027C6.8404 71.8327 9.2504 74.0527 11.6904 75.3227C14.1404 76.5927 16.6104 76.9127 20.0904 76.6227C23.5704 76.3327 28.0704 75.4127 31.9404 74.6327C35.8104 73.8527 39.0704 73.2027 41.8004 72.9127C44.5404 72.6127 46.7504 72.6827 48.9004 73.0427C51.0504 73.4027 53.1304 74.0527 55.3804 74.7627C57.6204 75.4827 60.0304 76.2627 62.1804 76.4627C64.3304 76.6527 66.2204 76.2627 68.8204 75.1927C71.4304 74.1127 74.7504 72.3527 77.2904 70.2127C79.8204 68.0627 81.5804 65.5227 83.1804 62.9127C84.7704 60.3127 86.2004 57.6427 87.1504 55.0427C88.0904 52.4327 88.5504 49.8927 88.6804 47.7127C88.8104 45.5327 88.6104 43.7127 88.3204 41.7927C88.0304 39.8727 87.6404 37.8527 85.4604 32.2227C83.2804 26.5927 79.3004 17.3427 76.4104 12.0327C73.5104 6.73275 71.6904 5.36274 69.1504 4.12275C66.6104 2.89275 63.3504 1.78275 57.1704 1.20275Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M52.481 30.1719C49.101 33.2919 45.711 36.4219 44.051 38.5019C42.391 40.5819 42.461 41.6219 42.961 47.1619C43.471 52.6919 44.411 62.7119 45.361 72.7319"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
      <path
        d="M44.05 38.5037C37.61 36.1137 31.18 33.7337 24.75 31.3438"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
